import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { forkJoin, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { Networks } from 'src/app/modules/shared/models/networks.enum';
import { PostMessageService } from 'src/app/modules/shared/services/post-message.service';
import {SwiperOptions} from 'swiper';
import { BookingService } from '../../../shared/services/booking.service';
import { HolidayPrefetchService } from '../../../shared/services/holiday-prefetch.service';
import { ProjectService } from '../../../shared/services/project.service';
import { IEngineTab } from '../../interfaces/iengine-tab';
import { EngineTabTypes } from '../../models/engine-tab-types.enum';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalStatusService} from '../../../shared/services/modal-status.service';
import {catchError, map, takeUntil} from 'rxjs/operators';
import { CmsService } from 'src/app/modules/cms/services/cms.service';

@Component({
  selector: 'app-engine-tabs',
  templateUrl: './engine-tabs.component.html',
  styleUrls: ['./engine-tabs.component.scss']
})
export class EngineTabsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() selectedTabOuter: EngineTabTypes;
  @Input() isB2B;
  @Output() selectedTab: EventEmitter<EngineTabTypes> = new EventEmitter<EngineTabTypes>();

  tabs$: Observable<IEngineTab[]>;
  selectedTabInner: EngineTabTypes;
  hasMerlinxSubscription: Subscription;

  config: SwiperOptions = {
    breakpoints: {
      320: {
        slidesPerView: 2,
        simulateTouch: true,
        allowTouchMove: true
      },
      560: {
        slidesPerView: 3,
        simulateTouch: true,
        allowTouchMove: true
      },
      840: {
        slidesPerView: 5,
        simulateTouch: true,
        allowTouchMove: true
      },
      1000: {
        slidesPerView: 7,
        simulateTouch: false,
        allowTouchMove: false
      },
      1440: {
        slidesPerView: 8,
        simulateTouch: false,
        allowTouchMove: false
      },
      1600: {
        slidesPerView: 10,
        simulateTouch: false,
        allowTouchMove: false
      }
    },
    simulateTouch: true,
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };
  index;
  public hasWelgo;

  private unsubscribe$ = new Subject();

  constructor(
    private _modalService: NgbModal,
    private _modalStatusService: ModalStatusService,
    private _projectService: ProjectService,
    private _cmsService: CmsService,
    private _holidayPrefetchService: HolidayPrefetchService,
    private _bookingService: BookingService,
    private _postMessageService: PostMessageService
    ) {
      this._cmsService.hasWelgoService$.pipe(takeUntil(this.unsubscribe$))
        .subscribe((hasWelgoService) => {
          this.hasWelgo = hasWelgoService;
      });
    }

  ngOnInit() {

    // this.hasMerlinxSubscription = this._projectService.hasMerlinxTabs().subscribe(e => {
    //   this.tabs$ = of([
    //     {id: EngineTabTypes.Holiday, name: 'Vacanze', icon: 'icon-palm-tree', enabled: true},
    //     {id: EngineTabTypes.Cruise, name: 'Crociere', icon: 'icon-cruise', enabled: true},
    //     {id: EngineTabTypes.Tour, name: 'Tour', icon: 'icon-tour', enabled: true},
    //     {id: EngineTabTypes.Bus, name: 'Viaggi in Bus', icon: 'g-icon-bus-filled', enabled: true},
    //     {id: EngineTabTypes.Flight, name: 'Voli', icon: 'g-icon-flight', enabled: e},
    //     {id: EngineTabTypes.Hotel, name: 'Hotel', icon: 'icon-double-bed', enabled: e},
    //     {id: EngineTabTypes.CarRental, name: 'Noleggio', icon: 'icon-rental', enabled: e},
    //     {id: EngineTabTypes.Parking, name: 'Parcheggio', icon: 'icon-parking', enabled: e},
    //   ]);
    //   setTimeout(() => this.selectTab(this.selectedTabOuter || EngineTabTypes.Holiday), 0);
    // });
  }

  ngOnDestroy() {
    this.hasMerlinxSubscription?.unsubscribe();
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.isB2B !== undefined && this.isB2B !== undefined) {
      this.initializeTabs();
    }
  }

  initializeTabs() {
    const additionalFunct = [];
    this._projectService.getAgencyNetwork().toPromise().then(
      (resolve) => {
        additionalFunct.push(this._projectService.hasWelcomeToItalyTabs());
        additionalFunct.push(this._projectService.getWidgetExtra());
        if (
          Number(resolve.id_network) &&
          Number(resolve.id_network) === Networks.WTG
        ) {
          additionalFunct.push(this._projectService.getMerlinxCode());
        }

        forkJoin([this._projectService.hasMerlinxTabs(), ...additionalFunct])
          .toPromise()
          .then(
            (resolved: any[]) => {
              const hasWelcomeToItalyTabs = resolved[1] || false;
              const tabsToEnable = resolved[2]?.enabledTabs || [];

              // filtro i nomi delle tab da abilitare (se presenti) con quello delle tab dell'engine (i nomi delle tab che non corrispondono, vengono scartati)
              const tabsToEnableFiltered = tabsToEnable
                  ?.map((tab) => tab?.trim()?.toLowerCase() || '')
                  ?.filter((tab) => Object.values(EngineTabTypes).includes(tab)) || [];

              let hasMerlinxTabs: boolean;
              if (
                  Number(resolve.id_network) &&
                  Number(resolve.id_network) === Networks.WTG
              ) {
                // se si tratta di un sito wtg, verifico se è presente sia il parametro "THIRDPART" che il codice esterno dell'agenzia
                hasMerlinxTabs = (resolved[0] && resolved[3]) || false;
              } else {
                // se si tratta di un sito GEO o non WTG, verifico se ha le tab merlinx attive attraverso un codice esterno che verrà ritornato
                // (se viene ritornato quel codice allora attiva le varie tabs, per maggiori informazioni vedere il metodo hasMerlinxTabs)
                hasMerlinxTabs = resolved[0];
              }

              this.tabs$ = of([
                {
                  id: EngineTabTypes.Holiday,
                  name: 'Vacanze',
                  icon: 'icon-palm-tree',
                  enabled: true,
                },
                {
                  id: EngineTabTypes.Cruise,
                  name: 'Crociere',
                  icon: 'icon-cruise',
                  enabled: true,
                },
               /* {
                  id: EngineTabTypes.WelcomeToItaly,
                  name: 'Welcome To Italy',
                  icon: 'icon-pin',
                  enabled: hasWelcomeToItalyTabs,
                },*/
                {
                  id: EngineTabTypes.SmartBox,
                  name: 'SmartBox',
                  icon: 'g-icon-smartbox',
                  enabled: this.isB2B,
                },
                {
                  id: EngineTabTypes.Tour,
                  name: 'Tour',
                  icon: 'icon-tour',
                  enabled: !(this.isB2B &&  Number(resolve.id_network) === Networks.WTG),
                },
                {
                  id: EngineTabTypes.Bus,
                  name: 'Viaggi in Bus',
                  icon: 'g-icon-bus-filled',
                  enabled: false,
                },
                {
                  id: EngineTabTypes.Flight,
                  name: 'Voli',
                  icon: 'g-icon-flight',
                  enabled: hasMerlinxTabs || this.hasWelgo, //resolved[3] ? resolved[3] : resolved[0],
                },
                {
                  id: EngineTabTypes.Hotel,
                  name: 'Hotel',
                  icon: 'icon-double-bed',
                  // enabled: resolved[3] ? resolved[3] : resolved[0],
                  enabled: false,
                },
     /*           {
                  id: EngineTabTypes.CarRental,
                  name: 'Noleggio',
                  icon: 'icon-rental',
                  enabled: hasMerlinxTabs || this.hasWelgo, // resolved[3] ? resolved[3] : resolved[0],
                },
                {
                  id: EngineTabTypes.Parking,
                  name: 'Parcheggio',
                  icon: 'icon-parking',
                  enabled: hasMerlinxTabs || this.hasWelgo, // resolved[3] ? resolved[3] : resolved[0],
                },*/
              ]).pipe(
                  map((allEngineTabs) => {
                    // abilito i tab indicati nell'array
                    if (tabsToEnableFiltered?.length > 0) {
                      const allEngineTabsUpdated = allEngineTabs.map((tab) => {
                        tab.enabled = tabsToEnableFiltered.includes(tab.id);
                        return tab;
                      });

                      // seleziono di default il primo tab abilitato se presente, altrimenti, seleziono il tab holiday
                      this.selectedTabOuter = allEngineTabsUpdated.find((tab) => tab.enabled)?.id || EngineTabTypes.Holiday;
                      return allEngineTabsUpdated;
                    }
                    return allEngineTabs;
                  }),
                  catchError(err => throwError(err))
              );
              setTimeout(
                () =>
                  this.selectTab(
                    this.selectedTabOuter || EngineTabTypes.Holiday
                  ),
                50
              );
            },
            (rejected) => console.error(rejected)
          );
      },
      (reject) => {
        console.error(reject);
      }
    );
  }

  selectTab(tabId: EngineTabTypes) {
    this.selectedTabInner = tabId;
    this.selectedTab.emit(tabId);

    if (this._modalService.hasOpenModals()) {
      // se sono presenti modali aperte, le chiudo
      this._modalService.dismissAll();
      this._modalStatusService.hasOpenModals.next(false);
    }
  }

  tabVisible(tab: IEngineTab): boolean {
    return tab.enabled;
  }

}
